// extracted by mini-css-extract-plugin
module.exports = {"Container":"Turismo_Container__25RC_","LinkList":"Turismo_LinkList__ZX21m","Lugares":"Turismo_Lugares__18kOE"};